<script setup lang="ts">
import { MetaTitle } from "@/types/Facet";

const metaTitle: MetaTitle = useState("metaTitle");
metaTitle.value = `サイトマップ`; // meta title定義

useSeoMeta({
  title: `${metaTitle.value}`,
  keywords: "火災保険,保険スクエアbang!",
  description:
    "「保険スクエアbang! 火災保険」のサイトマップです。比較・見積もり、火災保険の基礎知識、地震保険の基礎知識、運営情報など各ページを一覧で確認いただけます。",
  ogTitle: `${metaTitle.value}`,
  ogDescription:
    "「保険スクエアbang! 火災保険」のサイトマップです。比較・見積もり、火災保険の基礎知識、地震保険の基礎知識、運営情報など各ページを一覧で確認いただけます。",
  ogUrl: "https://fire.bang.co.jp/sitemap/",
});
</script>

<template>
  <div>
    <main>
      <OrganismsBreadcrumbs />
      <h1>サイトマップ</h1>
      <div class="sitemap">
        <ul>
          <li>
            <h2>火災保険の基礎知識</h2>
            <ul>
              <li><a href="/cate/basic/">火災保険の記事一覧</a></li>
            </ul>
          </li>
          <li>
            <h2>地震保険の基礎知識</h2>
            <ul>
              <li><a href="/cate/jishin-basic/">地震保険の記事一覧</a></li>
            </ul>
          </li>
        </ul>
        <ul>
          <li>
            <h2>保険スクエアbang! 火災保険について</h2>
            <ul>
              <li><a href="/">保険スクエアbang! 火災保険TOP</a></li>
              <li>
                <a href="javascript:void(0);" @click="$popUp.privacyWin()"
                  >プライバシーポリシー</a
                >
              </li>
              <li>
                <a href="javascript:void(0);" @click="$popUp.termWin()">
                  利用規約
                </a>
              </li>
              <li>
                <a
                  href="https://www.webcrew.co.jp/"
                  target="_blank"
                  rel="noopener"
                  >運営会社</a
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </main>
  </div>
</template>

<style lang="scss" scoped>
main {
  padding-bottom: 9.6%;
  position: relative;
}
h1 {
  margin-bottom: 5.33%;
  padding: 1em 4%;
  font-size: px(19.9);
  font-weight: 700;
  background: url(~/assets/images/bg_pattern_02.gif) no-repeat 0 0;
  background-size: 100% 100%;
}
h2 {
  margin-bottom: 2.5%;
  padding: 0 0 0.4em 0.7em;
  border-bottom: 1px solid #dcdcdc;
  font-size: px(16.8);
  font-weight: 700;
  position: relative;
  line-height: 1.2;
  &::before {
    content: '';
    margin: 0 0.5em 0 0;
    width: 5px;
    height: 80%;
    background-color: $colorDarkBlue;
    position: absolute;
    top: 0;
    left: 0;
  }
}
.sitemap {
  padding: 0 4%;
  > ul {
    margin-bottom: 10.7%;
    &:last-child {
      margin-bottom: 0;
    }
    > li {
      margin-bottom: 10.7%;
      &:last-child {
        margin-bottom: 0;
      }
      > ul {
        li {
          margin-bottom: 3.2%;
          &:last-child {
            margin-bottom: 0;
          }
          a {
            display: block;
            padding: 0 0 0 4.4%;
            position: relative;
            background: url(~/assets/images/sitemap/arrow_right_sp.png)
              no-repeat left center;
            background-size: 2.5%;
            color: $colorDarkBlue;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
@include media(pc) {
  main {
    margin: 0 auto;
    padding-bottom: 27px;
    width: $pcWrapWidth;
  }
  h1 {
    margin-bottom: 30px;
    padding: 18px 18px 20px;
    font-size: px(31.9);
  }
  h2 {
    margin: 0 0 16px 0;
    padding: 0 0 0.4em 0.7em;
    font-size: px(21.9);
  }
  .sitemap {
    padding: 0;
    display: flex;
    > ul {
      margin-bottom: 0;
      margin-right: 40px;
      width: 460px;
      &:last-child {
        margin-right: 0;
      }
      > li {
        margin-bottom: 40px;
        > ul {
          li {
            a {
              padding: 0 0 0 17px;
              background: url(~/assets/images/sitemap/arrow_right_pc.png)
                no-repeat left center;
              background-size: 10px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
